export default function runDivisadero() {
    // var checkExist_alternativa_1 = setInterval(function () {
    //     //Si existe el elemento, cancelamos el interval y ejecutamos el código necesario
    //     if (jQuery("[mfc-properties*='fechaInicioDobleCalendario']:eq(0) div.hidden").length >= 1
    //         && jQuery("[mfc-properties*='fechaInicio']:eq(1) div#fechaInicio").length >= 1) {
    //         clearInterval(checkExist_alternativa_1);

    //         runTest_Alternativa_1();
    //     }
    // }, 100);

    var checkExist_alternativa_1 = setInterval(function () {
        var primerCalendarioDoble = document.querySelector("[mfc-properties*='fechaInicioDobleCalendario']:nth-of-type(1) div.hidden");
        var segundoCalendario = document.querySelector("[mfc-properties*='fechaInicio']:nth-of-type(2) div#fechaInicio");

        // Si existe el elemento, cancelamos el interval y ejecutamos el código necesario
        if (primerCalendarioDoble && segundoCalendario) {
            clearInterval(checkExist_alternativa_1);
            runTest_Alternativa_1();
        }
    }, 100);


    function runTest_Alternativa_1() {
        window.click_fecha_no_permitida = false;

        if (document.querySelectorAll('mfc-calendar:nth-of-type(1) section table td[class*="mfc-u-calendar__day__actualmonth"]:not(.mfc-u-calendar__day__disabled)').length < 31) {
            // if (jQuery('mfc-calendar:nth-of-type(1) section table td[class*="mfc-u-calendar__day__actualmonth"]:not(.mfc-u-calendar__day__disabled)').length < 31) {
            // if (sessionStorage.getItem("mkdiv_date_calendar_step") != null) {
            //     var first_calendar_cell = jQuery('mfc-calendar:nth-of-type(1) section table td[class*="mfc-u-calendar__day__actualmonth"]:not(.mfc-u-calendar__day__disabled):eq(0)').attr("id");
            //     var first_calendar_dayString = first_calendar_cell.substring(first_calendar_cell.indexOf("y") + 1);
            //     var first_calendar_month = first_calendar_cell.substring(first_calendar_cell.indexOf("th") + 2);

            //     var date = sessionStorage.getItem("mkdiv_date_calendar_step").split("-");
            //     var today = new Date();

            //     var actual_month = today.getMonth() + 1;

            //     if (first_calendar_month > actual_month) {
            //         if (date[1] > actual_month) {
            //             jQuery("[mfc-properties*='fechaInicio']:eq(1) [ng-click='getNextMonth(-1)']").click();
            //             jQuery("[mfc-properties*='fechaInicioDobleCalendario']:eq(0) [ng-click='getNextMonth(-1)']").click();

            //             var checkExist_second_calendar_day = setInterval(function () {
            //                 //Si existe el elemento, cancelamos el interval y ejecutamos el código necesario
            //                 if (jQuery("#fechaInicioDobleCalendario-day" + date[0] + "-month" + date[1]).length >= 1) {
            //                     clearInterval(checkExist_second_calendar_day);

            //                     jQuery("#fechaInicioDobleCalendario-day" + date[0] + "-month" + date[1]).mousedown();
            //                 }
            //             }, 100);
            //         }
            //     }
            // }

            if (sessionStorage.getItem("mkdiv_date_calendar_step") != null) {
                var first_calendar_cell = document.querySelector('mfc-calendar:nth-of-type(1) section table td[class*="mfc-u-calendar__day__actualmonth"]:not(.mfc-u-calendar__day__disabled)');

                if (first_calendar_cell) {
                    var first_calendar_id = first_calendar_cell.getAttribute("id");
                    var first_calendar_dayString = first_calendar_id.substring(first_calendar_id.indexOf("y") + 1);
                    var first_calendar_month = first_calendar_id.substring(first_calendar_id.indexOf("th") + 2);

                    var date = sessionStorage.getItem("mkdiv_date_calendar_step").split("-");
                    var today = new Date();

                    var actual_month = today.getMonth() + 1;

                    if (first_calendar_month > actual_month) {
                        if (date[1] > actual_month) {

                            var prevMonthButton1 = document.querySelector("[mfc-properties*='fechaInicio']:nth-of-type(2) [ng-click='getNextMonth(-1)']");
                            if (prevMonthButton1) {
                                prevMonthButton1.click();
                            }

                            var prevMonthButton2 = document.querySelector("[mfc-properties*='fechaInicioDobleCalendario']:nth-of-type(1) [ng-click='getNextMonth(-1)']");
                            if (prevMonthButton2) {
                                prevMonthButton2.click();
                            }

                            var checkExist_second_calendar_day = setInterval(function () {
                                var second_calendar_day = document.querySelector("#fechaInicioDobleCalendario-day" + date[0] + "-month" + date[1]);
                                if (second_calendar_day) {
                                    clearInterval(checkExist_second_calendar_day);
                                    second_calendar_day.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
                                }
                            }, 100);
                        }
                    }
                }
            }

            //Avanza el segundo calendario al mes siguiente
            // jQuery("[mfc-properties*='fechaInicioDobleCalendario']:eq(0) [ng-click='getNextMonth(1)']").click();
            var nextMonthButton = document.querySelector("[mfc-properties*='fechaInicioDobleCalendario']:nth-of-type(1) [ng-click='getNextMonth(1)']");

            if (nextMonthButton) nextMonthButton.click();

            muestraSegundoCalendario();
            ocultaflechasCalendarios();
            //sobreescribeEventosCalendar();

            /*function sobreescribeEventosCalendar(){		
                jQuery("[mfc-properties*='fechaInicioDobleCalendario']:eq(0) section table td.mfc-u-calendar__day__actualmonth").off("click");
    
                for(var i = 0; i < jQuery("[mfc-properties*='fechaInicioDobleCalendario']:eq(0) section table td.mfc-u-calendar__day__actualmonth").length; i++){		
                    jQuery("[mfc-properties*='fechaInicioDobleCalendario']:eq(0) section table td.mfc-u-calendar__day__actualmonth:eq(" + i + ")").click(function(){
                        document.querySelectorAll("input[name='fechaInicio']")[0].setAttribute("value", document.querySelectorAll("input[name*='fechaInicioDobleCalendario']")[0].getAttribute("value"));
    
                        jQuery("button[ng-if='next']").mousedown();		
                    });
                }
            }*/

            // function muestraSegundoCalendario() {
            //     //Clases de Angular para que cada calendario ocupe la mitad de la pantalla disponible
            //     jQuery("[mfc-properties*='fechaInicioDobleCalendario']:eq(0) div.hidden").addClass("mfc-col-2");
            //     jQuery("[mfc-properties*='fechaInicio']:eq(1) div#fechaInicio").addClass("mfc-col-2");

            //     //Se muestra el segundo calendario
            //     jQuery("[mfc-properties*='fechaInicioDobleCalendario']:eq(0) div.hidden").removeClass("hidden");
            // }

            // function ocultaflechasCalendarios() {
            //     //Flechas calendario original
            //     jQuery("[mfc-properties*='fechaInicio']:eq(1) [ng-click='getNextMonth(-1)']").hide();
            //     jQuery("[mfc-properties*='fechaInicio']:eq(1) [ng-click='getNextMonth(1)']").hide();

            //     //Flechas segundo calendario
            //     jQuery("[mfc-properties*='fechaInicioDobleCalendario']:eq(0) [ng-click='getNextMonth(-1)']").hide();
            //     jQuery("[mfc-properties*='fechaInicioDobleCalendario']:eq(0) [ng-click='getNextMonth(1)']").hide();
            // }

            function muestraSegundoCalendario() {
                var primerCalendario = document.querySelector("[mfc-properties*='fechaInicioDobleCalendario']:nth-of-type(1) div.hidden");
                var segundoCalendario = document.querySelector("[mfc-properties*='fechaInicio']:nth-of-type(2) div#fechaInicio");

                if (primerCalendario) {
                    primerCalendario.classList.add("mfc-col-2");
                }
                if (segundoCalendario) {
                    segundoCalendario.classList.add("mfc-col-2");
                }

                if (primerCalendario) {
                    primerCalendario.classList.remove("hidden");
                }
            }

            function ocultaflechasCalendarios() {
                var flechaAnteriorCalendarioOriginal = document.querySelector("[mfc-properties*='fechaInicio']:nth-of-type(2) [ng-click='getNextMonth(-1)']");
                var flechaSiguienteCalendarioOriginal = document.querySelector("[mfc-properties*='fechaInicio']:nth-of-type(2) [ng-click='getNextMonth(1)']");

                if (flechaAnteriorCalendarioOriginal) {
                    flechaAnteriorCalendarioOriginal.style.display = 'none';
                }
                if (flechaSiguienteCalendarioOriginal) {
                    flechaSiguienteCalendarioOriginal.style.display = 'none';
                }

                var flechaAnteriorSegundoCalendario = document.querySelector("[mfc-properties*='fechaInicioDobleCalendario']:nth-of-type(1) [ng-click='getNextMonth(-1)']");
                var flechaSiguienteSegundoCalendario = document.querySelector("[mfc-properties*='fechaInicioDobleCalendario']:nth-of-type(1) [ng-click='getNextMonth(1)']");

                if (flechaAnteriorSegundoCalendario) {
                    flechaAnteriorSegundoCalendario.style.display = 'none';
                }
                if (flechaSiguienteSegundoCalendario) {
                    flechaSiguienteSegundoCalendario.style.display = 'none';
                }
            }
        } else {
            // jQuery("[mfc-properties*='fechaInicio']:eq(1) div[ng-click='getNextMonth(-1)'], [mfc-properties*='fechaInicio']:eq(1) div[ng-click='getNextMonth(1)']").click(function () {
            //     jQuery("mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled),\
            //  mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__nextmonth']:not(.mfc-u-calendar__day__disabled),\
            //  mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__prevmonth']:not(.mfc-u-calendar__day__disabled),\
            //  mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled)").mousedown(function () {
            //         /* MEDICIÓN */
            //         var event = {
            //             'hitType': 'event',
            //             'eventCategory': 'testing',
            //             'eventAction': 'ao43 - mvt paso calendario',
            //             'eventLabel': 'acceso codigo postal'
            //         }

            //         gaSendEvent(event);
            //     });
            // });

            var nextPrevButtons = document.querySelectorAll("[mfc-properties*='fechaInicio']:nth-of-type(2) div[ng-click='getNextMonth(-1)'], [mfc-properties*='fechaInicio']:nth-of-type(2) div[ng-click='getNextMonth(1)']");

            nextPrevButtons.forEach(function (button) {
                button.addEventListener("click", function () {
                    var calendarDays = document.querySelectorAll(
                        "mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled), " +
                        "mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__nextmonth']:not(.mfc-u-calendar__day__disabled), " +
                        "mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__prevmonth']:not(.mfc-u-calendar__day__disabled), " +
                        "mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled)"
                    );

                    calendarDays.forEach(function (day) {
                        day.addEventListener("mousedown", function () {
                            /* MEDICIÓN */
                            var event = {
                                'hitType': 'event',
                                'eventCategory': 'testing',
                                'eventAction': 'ao43 - mvt paso calendario',
                                'eventLabel': 'acceso codigo postal'
                            };

                            gaSendEvent(event);
                        });
                    });
                });
            });
        }

        // jQuery("mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled),\
        //      mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__nextmonth']:not(.mfc-u-calendar__day__disabled),\
        //      mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__prevmonth']:not(.mfc-u-calendar__day__disabled),\
        //      mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled)").mousedown(function () {
        //     /* DÍA SELECCIONADO */
        //     var cell = jQuery(this).attr("id");

        //     var dayString = cell.substring(cell.indexOf("y") + 1);
        //     var day = dayString.substring(0, dayString.indexOf("-"));

        //     var month = cell.substring(cell.indexOf("th") + 2);
        //     var year = new Date().getFullYear();

        //     sessionStorage.setItem("mkdiv_date_calendar_step", day + "-" + month + "-" + year);
        // });


        var calendarDays = document.querySelectorAll(
            "mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled), " +
            "mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__nextmonth']:not(.mfc-u-calendar__day__disabled), " +
            "mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__prevmonth']:not(.mfc-u-calendar__day__disabled), " +
            "mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled)"
        );

        calendarDays.forEach(function (day) {
            day.addEventListener("mousedown", function () {
                /* DÍA SELECCIONADO */
                var cellId = this.getAttribute("id");

                var dayString = cellId.substring(cellId.indexOf("y") + 1);
                var day = dayString.substring(0, dayString.indexOf("-"));

                var month = cellId.substring(cellId.indexOf("th") + 2);
                var year = new Date().getFullYear();

                sessionStorage.setItem("mkdiv_date_calendar_step", day + "-" + month + "-" + year);
            });
        });

        // jQuery("mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled),\
        //      mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__nextmonth']:not(.mfc-u-calendar__day__disabled),\
        //      mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__prevmonth']:not(.mfc-u-calendar__day__disabled),\
        //      mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled)").mousedown(function () {
        //     /* MEDICIÓN */
        //     var event = {
        //         'hitType': 'event',
        //         'eventCategory': 'testing',
        //         'eventAction': 'ao43 - mvt paso calendario',
        //         'eventLabel': 'acceso codigo postal'
        //     }

        //     gaSendEvent(event);

        //     jQuery("#estilos_popup_variante").remove();

        //     jQuery(document).on("click", ".DCSS-c2c .DCS-ClickToCall", function () {
        //         jQuery(".DCS-headerFormTitle").html("Te llamamos gratis");
        //     });

        //     jQuery("#DCS-phone").attr("placeholder", "Tu número de teléfono");
        //     jQuery("#DCS-CP").attr("placeholder", "Tu código postal");

        //     jQuery("#mkdiv_p_tel").remove();
        //     jQuery("#mkdiv_p_cp").remove();
        // });

        var calendarDays = document.querySelectorAll(
            "mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled), " +
            "mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__nextmonth']:not(.mfc-u-calendar__day__disabled), " +
            "mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__prevmonth']:not(.mfc-u-calendar__day__disabled), " +
            "mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__actualmonth']:not(.mfc-u-calendar__day__disabled)"
        );

        calendarDays.forEach(function (day) {
            day.addEventListener("mousedown", function () {
                /* MEDICIÓN */
                var event = {
                    'hitType': 'event',
                    'eventCategory': 'testing',
                    'eventAction': 'ao43 - mvt paso calendario',
                    'eventLabel': 'acceso codigo postal'
                };

                gaSendEvent(event);

                var estilosPopupVariante = document.getElementById("estilos_popup_variante");
                if (estilosPopupVariante) {
                    estilosPopupVariante.remove();
                }

                document.addEventListener("click", function (event) {
                    if (event.target.closest(".DCSS-c2c .DCS-ClickToCall")) {
                        document.querySelector(".DCS-headerFormTitle").innerHTML = "Te llamamos gratis";
                    }
                });

                var phoneInput = document.getElementById("DCS-phone");
                var cpInput = document.getElementById("DCS-CP");

                if (phoneInput) {
                    phoneInput.setAttribute("placeholder", "Tu número de teléfono");
                }
                if (cpInput) {
                    cpInput.setAttribute("placeholder", "Tu código postal");
                }

                var mkdivPTel = document.getElementById("mkdiv_p_tel");
                var mkdivPCP = document.getElementById("mkdiv_p_cp");
                if (mkdivPTel) {
                    mkdivPTel.remove();
                }
                if (mkdivPCP) {
                    mkdivPCP.remove();
                }
            });
        });

        // jQuery("mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__actualmonth mfc-u-calendar__day__disabled'],\
        //  mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__prevmonth mfc-u-calendar__day__disabled'],\
        //  mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__nextmonth mfc-u-calendar__day__disabled'],\
        //  mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__actualmonth mfc-u-calendar__day__disabled'],\
        //  mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__prevmonth mfc-u-calendar__day__disabled'],\
        //  mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__nextmonth mfc-u-calendar__day__disabled']").click(function () {
        //     runTest_pop_up();

        //     var event = {
        //         'hitType': 'event',
        //         'eventCategory': 'testing',
        //         'eventAction': 'ao43 - mvt paso calendario',
        //         'eventLabel': 'click fecha no permitida'
        //     }

        //     gaSendEvent(event);

        //     window.click_fecha_no_permitida = true;

        //     jQuery(".DCSS-c2c > .DCS-ClickToCall").click();
        // });

        var disabledDays = document.querySelectorAll(
            "mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__actualmonth mfc-u-calendar__day__disabled'], " +
            "mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__prevmonth mfc-u-calendar__day__disabled'], " +
            "mfc-calendar:nth-of-type(1) section table td[class*='mfc-u-calendar__day__nextmonth mfc-u-calendar__day__disabled'], " +
            "mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__actualmonth mfc-u-calendar__day__disabled'], " +
            "mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__prevmonth mfc-u-calendar__day__disabled'], " +
            "mfc-calendar div#fechaInicioDobleCalendario section table td[class*='mfc-u-calendar__day__nextmonth mfc-u-calendar__day__disabled']"
        );

        disabledDays.forEach(function (day) {
            day.addEventListener("click", function () {
                runTest_pop_up();

                var event = {
                    'hitType': 'event',
                    'eventCategory': 'testing',
                    'eventAction': 'ao43 - mvt paso calendario',
                    'eventLabel': 'click fecha no permitida'
                };

                gaSendEvent(event);

                window.click_fecha_no_permitida = true;

                var clickToCallButton = document.querySelector(".DCSS-c2c > .DCS-ClickToCall");
                if (clickToCallButton) {
                    clickToCallButton.click();
                }
            });
        });

        // jQuery(document).on("click", "#dmv-content .DCS-headerFormClose", function () {
        //     window.click_fecha_no_permitida = false;

        //     while (jQuery(".DCS-bodyFormInput:eq(1)").find('div:has(> span.DCS-errorMsj)').length > 0) {
        //         jQuery(".DCS-bodyFormInput:eq(1)").find('div:has(> span.DCS-errorMsj)').eq(jQuery(".DCS-bodyFormInput:eq(1)").find('div:has(> span.DCS-errorMsj)').length - 1).remove();
        //     }

        //     while (jQuery(".DCS-bodyFormInput:eq(2)").find('div:has(> span.DCS-errorMsj)').length > 0) {
        //         jQuery(".DCS-bodyFormInput:eq(2)").find('div:has(> span.DCS-errorMsj)').eq(jQuery(".DCS-bodyFormInput:eq(2)").find('div:has(> span.DCS-errorMsj)').length - 1).remove();
        //     }
        // });

        // jQuery(document).on("click", ".DCS-footerForm > button.DCS-footerFormButton", function () {
        //     while (jQuery(".DCS-bodyFormInput:eq(1)").find('div:has(> span.DCS-errorMsj)').length > 1) {
        //         jQuery(".DCS-bodyFormInput:eq(1)").find('div:has(> span.DCS-errorMsj)').eq(jQuery(".DCS-bodyFormInput:eq(1)").find('div:has(> span.DCS-errorMsj)').length - 1).remove();
        //     }

        //     while (jQuery(".DCS-bodyFormInput:eq(2)").find('div:has(> span.DCS-errorMsj)').length > 1) {
        //         jQuery(".DCS-bodyFormInput:eq(2)").find('div:has(> span.DCS-errorMsj)').eq(jQuery(".DCS-bodyFormInput:eq(2)").find('div:has(> span.DCS-errorMsj)').length - 1).remove();
        //     }
        // });


        document.addEventListener("click", function (event) {
            if (event.target.matches("#dmv-content .DCS-headerFormClose")) {
                window.click_fecha_no_permitida = false;


                var bodyFormInput1 = document.querySelectorAll(".DCS-bodyFormInput")[1];
                removeErrorMessages(bodyFormInput1);


                var bodyFormInput2 = document.querySelectorAll(".DCS-bodyFormInput")[2];
                removeErrorMessages(bodyFormInput2);
            }
        });

        document.addEventListener("click", function (event) {
            if (event.target.matches(".DCS-footerForm > button.DCS-footerFormButton")) {

                var bodyFormInput1 = document.querySelectorAll(".DCS-bodyFormInput")[1];
                removeExtraErrorMessages(bodyFormInput1);


                var bodyFormInput2 = document.querySelectorAll(".DCS-bodyFormInput")[2];
                removeExtraErrorMessages(bodyFormInput2);
            }
        });

        function removeErrorMessages(formInput) {
            var errorMessages = formInput.querySelectorAll("div:has(> span.DCS-errorMsj)");
            while (errorMessages.length > 0) {
                errorMessages[errorMessages.length - 1].remove();
                errorMessages = formInput.querySelectorAll("div:has(> span.DCS-errorMsj)");
            }
        }

        function removeExtraErrorMessages(formInput) {
            var errorMessages = formInput.querySelectorAll("div:has(> span.DCS-errorMsj)");
            while (errorMessages.length > 1) {
                errorMessages[errorMessages.length - 1].remove();
                errorMessages = formInput.querySelectorAll("div:has(> span.DCS-errorMsj)");
            }
        }

        // jQuery(document).on("mousedown", ".DCS-footerForm > button.DCS-footerFormButton", function () {
        //     if (window.click_fecha_no_permitida) {
        //         if (validar_telefono_codigo_postal()) {
        //             var event = {
        //                 'hitType': 'event',
        //                 'eventCategory': 'testing',
        //                 'eventAction': 'ao43 - mvt paso calendario',
        //                 'eventLabel': 'click fecha no permitida - call me-step2:success'
        //             }
        //         } else {
        //             var event = {
        //                 'hitType': 'event',
        //                 'eventCategory': 'testing',
        //                 'eventAction': 'ao43 - mvt paso calendario',
        //                 'eventLabel': 'click fecha no permitida - call me-step2:error'
        //             }
        //         }

        //         gaSendEvent(event);
        //     }
        // });

        document.addEventListener("mousedown", function (event) {
            if (event.target.matches(".DCS-footerForm > button.DCS-footerFormButton")) {
                if (window.click_fecha_no_permitida) {
                    var eventData;

                    if (validarTelefonoCodigoPostal()) {
                        eventData = {
                            'hitType': 'event',
                            'eventCategory': 'testing',
                            'eventAction': 'ao43 - mvt paso calendario',
                            'eventLabel': 'click fecha no permitida - call me-step2:success'
                        };
                    } else {
                        eventData = {
                            'hitType': 'event',
                            'eventCategory': 'testing',
                            'eventAction': 'ao43 - mvt paso calendario',
                            'eventLabel': 'click fecha no permitida - call me-step2:error'
                        };
                    }

                    gaSendEvent(eventData);
                }
            }
        });

        // jQuery("button[ng-if='next']").mousedown(function () {
        //     jQuery("#estilos_popup_variante").remove();

        //     jQuery(document).on("click", ".DCSS-c2c .DCS-ClickToCall", function () {
        //         jQuery(".DCS-headerFormTitle").html("Te llamamos gratis");
        //     });

        //     jQuery("#DCS-phone").attr("placeholder", "Tu número de teléfono");
        //     jQuery("#DCS-CP").attr("placeholder", "Tu código postal");

        //     jQuery("#mkdiv_p_tel").remove();
        //     jQuery("#mkdiv_p_cp").remove();
        // });

        // jQuery(document).on("click", ".DCS-headerFormClose", function () {
        //     jQuery("#estilos_popup").remove();

        //     jQuery(".DCS-headerFormTitle").html("Te llamamos gratis");

        //     jQuery("#DCS-phone").attr("placeholder", "Tu número de teléfono");
        //     jQuery("#DCS-CP").attr("placeholder", "Tu código postal");

        //     jQuery("#mkdiv_p_tel").remove();
        //     jQuery("#mkdiv_p_cp").remove();
        // });

        document.querySelector("button[ng-if='next']").addEventListener("mousedown", function () {
            var estilosPopupVariante = document.getElementById("estilos_popup_variante");
            if (estilosPopupVariante) {
                estilosPopupVariante.remove();
            }

            document.addEventListener("click", function (event) {
                if (event.target.closest(".DCSS-c2c .DCS-ClickToCall")) {
                    document.querySelector(".DCS-headerFormTitle").innerHTML = "Te llamamos gratis";
                }
            });

            var phoneInput = document.getElementById("DCS-phone");
            var cpInput = document.getElementById("DCS-CP");

            if (phoneInput) {
                phoneInput.setAttribute("placeholder", "Tu número de teléfono");
            }
            if (cpInput) {
                cpInput.setAttribute("placeholder", "Tu código postal");
            }

            var mkdivPTel = document.getElementById("mkdiv_p_tel");
            var mkdivPCP = document.getElementById("mkdiv_p_cp");
            if (mkdivPTel) {
                mkdivPTel.remove();
            }
            if (mkdivPCP) {
                mkdivPCP.remove();
            }
        });

        document.addEventListener("click", function (event) {
            if (event.target.closest(".DCS-headerFormClose")) {
                var estilosPopup = document.getElementById("estilos_popup");
                if (estilosPopup) {
                    estilosPopup.remove();
                }

                document.querySelector(".DCS-headerFormTitle").innerHTML = "Te llamamos gratis";

                if (phoneInput) {
                    phoneInput.setAttribute("placeholder", "Tu número de teléfono");
                }
                if (cpInput) {
                    cpInput.setAttribute("placeholder", "Tu código postal");
                }

                if (mkdivPTel) {
                    mkdivPTel.remove();
                }
                if (mkdivPCP) {
                    mkdivPCP.remove();
                }
            }
        });
    }

    function validar_telefono_codigo_postal() {
        // var retorno = false;
        // var pattern_telef = new RegExp("^[1-9]{9}$");

        // if (jQuery("#DCS-CP").val().length == 5 && parseInt(jQuery("#DCS-CP").val()) >= 1000 && parseInt(jQuery("#DCS-CP").val()) <= 52999
        //     && pattern_telef.test(jQuery("#DCS-phone").val())) {
        //     retorno = true;
        // }

        // return retorno;

        var retorno = false;
        var patternTelef = /^[1-9]{9}$/;

        var cpInput = document.getElementById("DCS-CP");
        var phoneInput = document.getElementById("DCS-phone");

        if (cpInput && phoneInput) {
            var cpValue = cpInput.value;
            var phoneValue = phoneInput.value;

            if (cpValue.length === 5 &&
                parseInt(cpValue) >= 1000 &&
                parseInt(cpValue) <= 52999 &&
                patternTelef.test(phoneValue)) {
                retorno = true;
            }
        }

        return retorno;
    }

    function runTest_pop_up() {
        // jQuery("head").append("<style id='estilos_popup' type='text/css'>\
        //  .dmv-content {\
        //      max-width: 970px !important;\
        //  }\
        //  .DCS-Form {\
        //      background: #FFF !important;\
        //      height: 612px;\
        //  }\
        //  .DCS-headerForm {\
        //      border-bottom: 0 !important;\
        //      padding: 34px 16px 0 0 !important;\
        //  }\
        //  .DCS-headerFormTitle {\
        //      padding-left: 25px;\
        //      padding-right: 25px;\
        //  }\
        //  .DCS-bodyFormMessage {\
        //      display: none;\
        //  }\
        //  .DCS-bodyFormInput {\
        //      margin-left: -62px;\
        //  }\
        //  .DCS-Form .DCS-bodyFormCheck {\
        //      padding: 24px;\
        //  }\
        //  .DCS-headerFormTitle, .DCS-Form .DCS-bodyFormInput, .DCS-footerForm, #cp-salud, div[class='DCS-bodyFormInput']:nth-child(1) {\
        //      text-align: center;\
        //  }\
        //  #DCS-phone, #DCS-CP {\
        //      width: 40%;\
        //  }\
        //  .DCS-footerForm button {\
        //      width: 49% !important;\
        //  }\
        //  #mkdiv_p_tel {\
        //      display: inline-block;\
        //      padding-right: 5px;\
        //      padding-left: 36px;\
        //  }\
        //  #mkdiv_p_cp {\
        //      display: inline-block;\
        //      padding-right: 8px;\
        //  }\
        //  @media (max-width: 960px) {\
        //      .DCS-headerForm {\
        //          padding: 34px 0px 0 0 !important;\
        //      }\
        //      .DCS-Form .DCS-headerFormClose img {\
        //          height: 10px;\
        //      }\
        //      .DCS-Form {\
        //          height: auto;\
        //      }\
        //      .DCS-Form .DCS-footerFormButton {\
        //          width: 100% !important;\
        //      }\
        //      .DCS-Form .DCS-bodyFormCheck {\
        //          padding: 0;\
        //      }\
        //      .DCS-bodyFormInput {\
        //          margin-left: 0;\
        //      }\
        //      #mkdiv_p_tel, #mkdiv_p_cp {\
        //          display: block;\
        //          text-align: left;\
        //          padding: 0;\
        //          font-size: 12px;\
        //      }\
        //      #DCS-phone, #DCS-CP {\
        //          width: 100%;\
        //      }\
        //      label[for='DCS-check'] {\
        //          font-weight: 300;\
        //      }\
        //  }\
        //  @media (min-width: 960px) {\
        //      .DCS-bodyFormInput > div {\
        //          width: 92%;\
        //          margin-left: 61px;\
        //      }\
        //  }\
        //  </style>");

        var style = document.createElement("style");
        style.id = "estilos_popup";
        style.type = "text/css";

        style.appendChild(document.createTextNode(
            ".dmv-content {" +
            "max-width: 970px !important;" +
            "}" +
            ".DCS-Form {" +
            "background: #FFF !important;" +
            "height: 612px;" +
            "}" +
            ".DCS-headerForm {" +
            "border-bottom: 0 !important;" +
            "padding: 34px 16px 0 0 !important;" +
            "}" +
            ".DCS-headerFormTitle {" +
            "padding-left: 25px;" +
            "padding-right: 25px;" +
            "}" +
            ".DCS-bodyFormMessage {" +
            "display: none;" +
            "}" +
            ".DCS-bodyFormInput {" +
            "margin-left: -62px;" +
            "}" +
            ".DCS-Form .DCS-bodyFormCheck {" +
            "padding: 24px;" +
            "}" +
            ".DCS-headerFormTitle, .DCS-Form .DCS-bodyFormInput, .DCS-footerForm, #cp-salud, div[class='DCS-bodyFormInput']:nth-child(1) {" +
            "text-align: center;" +
            "}" +
            "#DCS-phone, #DCS-CP {" +
            "width: 40%;" +
            "}" +
            ".DCS-footerForm button {" +
            "width: 49% !important;" +
            "}" +
            "#mkdiv_p_tel {" +
            "display: inline-block;" +
            "padding-right: 5px;" +
            "padding-left: 36px;" +
            "}" +
            "#mkdiv_p_cp {" +
            "display: inline-block;" +
            "padding-right: 8px;" +
            "}" +
            "@media (max-width: 960px) {" +
            ".DCS-headerForm {" +
            "padding: 34px 0px 0 0 !important;" +
            "}" +
            ".DCS-Form .DCS-headerFormClose img {" +
            "height: 10px;" +
            "}" +
            ".DCS-Form {" +
            "height: auto;" +
            "}" +
            ".DCS-Form .DCS-footerFormButton {" +
            "width: 100% !important;" +
            "}" +
            ".DCS-Form .DCS-bodyFormCheck {" +
            "padding: 0;" +
            "}" +
            ".DCS-bodyFormInput {" +
            "margin-left: 0;" +
            "}" +
            "#mkdiv_p_tel, #mkdiv_p_cp {" +
            "display: block;" +
            "text-align: left;" +
            "padding: 0;" +
            "font-size: 12px;" +
            "}" +
            "#DCS-phone, #DCS-CP {" +
            "width: 100%;" +
            "}" +
            "label[for='DCS-check'] {" +
            "font-weight: 300;" +
            "}" +
            "}" +
            "@media (min-width: 960px) {" +
            ".DCS-bodyFormInput > div {" +
            "width: 92%;" +
            "margin-left: 61px;" +
            "}" +
            "}"
        ));

        document.head.appendChild(style);

        // if (jQuery(".DCS-bodyRpContainer a.drp-phone").length == 0) {
        //     jQuery("head").append("<style type='text/css'>\
        //          .DCS-Form {\
        //              background: #FFF !important;\
        //              height: 480px;\
        //          }\
        //      </style>");
        // }

        // jQuery(".DCS-headerFormTitle").html("¿Te interesa una fecha posterior a 30 días?");

        // jQuery("#DCS-phone").removeAttr("placeholder");
        // jQuery("#DCS-CP").removeAttr("placeholder");

        // if (jQuery("#mkdiv_p_tel").length == 0 && jQuery("#mkdiv_p_cp").length == 0) {
        //     jQuery("<p id='mkdiv_p_tel'>Teléfono</p>").insertBefore(jQuery("#DCS-phone"));
        //     jQuery("<p id='mkdiv_p_cp'>Código postal</p>").insertBefore(jQuery("#DCS-CP"));
        // }

        if (document.querySelectorAll(".DCS-bodyRpContainer a.drp-phone").length === 0) {
            // Crear un nuevo elemento <style>
            var style = document.createElement("style");
            style.type = "text/css";
            style.appendChild(document.createTextNode(
                ".DCS-Form {" +
                "background: #FFF !important;" +
                "height: 480px;" +
                "}"
            ));

            // Agregar el nuevo <style> al <head>
            document.head.appendChild(style);
        }

        var headerTitle = document.querySelector(".DCS-headerFormTitle");
        if (headerTitle) {
            headerTitle.innerHTML = "¿Te interesa una fecha posterior a 30 días?";
        }

        var phoneInput = document.getElementById("DCS-phone");
        if (phoneInput) {
            phoneInput.removeAttribute("placeholder");
        }

        var cpInput = document.getElementById("DCS-CP");
        if (cpInput) {
            cpInput.removeAttribute("placeholder");
        }

        if (!document.getElementById("mkdiv_p_tel") && !document.getElementById("mkdiv_p_cp")) {
            var telParagraph = document.createElement("p");
            telParagraph.id = "mkdiv_p_tel";
            telParagraph.textContent = "Teléfono";
            phoneInput.parentNode.insertBefore(telParagraph, phoneInput);

            var cpParagraph = document.createElement("p");
            cpParagraph.id = "mkdiv_p_cp";
            cpParagraph.textContent = "Código postal";
            cpInput.parentNode.insertBefore(cpParagraph, cpInput);
        }
    }



    var checkExist_copy_title = setInterval(function () {
        //Si existe el elemento, cancelamos el interval y ejecutamos el código necesario
        // if (jQuery(".mfc-group-condition-container h2[ng-if='title']").length >= 1
        //     && jQuery("mfc-calendar:nth-of-type(1) section table").length >= 1
        //     && jQuery("mfc-calendar:nth-of-type(1) section table td").length == 35) {
        //     clearInterval(checkExist_copy_title);

        //     if (jQuery("#mkdiv_span_subtitle").length == 0) {
        //         runTest_Copy_title();
        //     }
        // }

        //Si existe el elemento, cancelamos el interval y ejecutamos el código necesario
        if (document.querySelectorAll(".mfc-group-condition-container h2[ng-if='title']").length >= 1
            && document.querySelectorAll("mfc-calendar:nth-of-type(1) section table").length >= 1
            && document.querySelectorAll("mfc-calendar:nth-of-type(1) section table td").length === 35) {

            clearInterval(checkExist_copy_title);

            if (!document.getElementById("mkdiv_span_subtitle")) {
                runTest_Copy_title();
            }
        }
    }, 100);

    function runTest_Copy_title() {
        // jQuery("head").append("<style type='text/css'>\
        //  #mkdiv_span_subtitle {\
        //      position: relative;\
        //        top: 20px;\
        //        font-size: 16px;\
        //    }\
        //  </style>");

        // jQuery(".mfc-group-condition-container h2[ng-if='title']").html("¿Cuándo te gustaría comenzar a disfrutar de tu seguro?");

        var styleElement = document.createElement("style");
        styleElement.type = "text/css";
        styleElement.innerHTML = `
            #mkdiv_span_subtitle {
                position: relative;
                top: 20px;
                font-size: 16px;
            }
        `;
        document.head.appendChild(styleElement);

        // Cambiar el contenido del título
        var titleElement = document.querySelector(".mfc-group-condition-container h2[ng-if='title']");
        if (titleElement) {
            titleElement.innerHTML = "¿Cuándo te gustaría comenzar a disfrutar de tu seguro?";
        }

        var contador_elemento = 0;

        var checkExist_elemento_calendar = setInterval(function () {
            //Si existe el elemento, cancelamos el interval y ejecutamos el código necesario
            // if (jQuery("#mkdiv_div_inputs_calendar").length >= 1) {
            //     clearInterval(checkExist_elemento_calendar);

            //     jQuery("#mkdiv_span_subtitle")
            //         .insertBefore(jQuery("#mkdiv_div_inputs_calendar"));
            // }

            if (document.getElementById("mkdiv_div_inputs_calendar")) {
                clearInterval(checkExist_elemento_calendar);

                var calendarElement = document.getElementById("mkdiv_div_inputs_calendar");
                var subtitleElement = document.getElementById("mkdiv_span_subtitle");

                if (subtitleElement) {
                    calendarElement.parentNode.insertBefore(subtitleElement, calendarElement);
                }
            }

            if (contador_elemento == 3000) {
                clearInterval(checkExist_elemento_calendar);
            }

            contador_elemento += 500;
        }, 500);
    }



    var checkExist_pop_up = setInterval(function () {
        //Si existe el elemento, cancelamos el interval y ejecutamos el código necesario
        // if (jQuery(".mfc-group-condition-container h2[ng-if='title']").length >= 1
        //     && jQuery("mfc-calendar:nth-of-type(1) section table").length >= 1
        //     && jQuery("mfc-calendar:nth-of-type(1) section table td").length == 35
        //     && jQuery(".DCS-headerFormTitle").length >= 1
        //     && jQuery("#DCS-phone").length >= 1
        //     && jQuery("#DCS-CP").length >= 1) {
        //     clearInterval(checkExist_pop_up);

        //     if (jQuery("#mkdiv_p_tel").length == 0) {
        //         runTest_pop_up();
        //     }
        // }

        //Si existe el elemento, cancelamos el interval y ejecutamos el código necesario
        if (document.querySelectorAll(".mfc-group-condition-container h2[ng-if='title']").length >= 1
            && document.querySelectorAll("mfc-calendar:nth-of-type(1) section table").length >= 1
            && document.querySelectorAll("mfc-calendar:nth-of-type(1) section table td").length === 35
            && document.querySelectorAll(".DCS-headerFormTitle").length >= 1
            && document.getElementById("DCS-phone") !== null
            && document.getElementById("DCS-CP") !== null) {

            clearInterval(checkExist_pop_up);

            if (document.getElementById("mkdiv_p_tel") === null) {
                runTest_pop_up();
            }
        }

    }, 100);

    function runTest_pop_up() {
        // jQuery("head").append("<style id='estilos_popup_variante' type='text/css'>\
        //  .dmv-content {\
        //      max-width: 970px !important;\
        //  }\
        //  .DCS-Form {\
        //      background: #FFF !important;\
        //      height: 612px;\
        //  }\
        //  .DCS-headerForm {\
        //      border-bottom: 0 !important;\
        //      padding: 34px 16px 0 0 !important;\
        //  }\
        //  .DCS-headerFormTitle {\
        //      padding-left: 25px;\
        //      padding-right: 25px;\
        //  }\
        //  .DCS-bodyFormMessage {\
        //      display: none;\
        //  }\
        //  .DCS-bodyFormInput {\
        //      margin-left: -62px;\
        //  }\
        //  .DCS-Form .DCS-bodyFormCheck {\
        //      padding: 24px;\
        //  }\
        //  .DCS-headerFormTitle, .DCS-Form .DCS-bodyFormInput, .DCS-footerForm, #cp-salud, div[class='DCS-bodyFormInput']:nth-child(1) {\
        //      text-align: center;\
        //  }\
        //  #DCS-phone, #DCS-CP {\
        //      width: 40%;\
        //  }\
        //  .DCS-footerForm button {\
        //      width: 49% !important;\
        //  }\
        //  #mkdiv_p_tel {\
        //      display: inline-block;\
        //      padding-right: 5px;\
        //      padding-left: 36px;\
        //  }\
        //  #mkdiv_p_cp {\
        //      display: inline-block;\
        //      padding-right: 8px;\
        //  }\
        //  @media (max-width: 960px) {\
        //      .DCS-headerForm {\
        //          padding: 34px 0px 0 0 !important;\
        //      }\
        //      .DCS-Form .DCS-headerFormClose img {\
        //          height: 10px;\
        //      }\
        //      .DCS-Form {\
        //          height: auto;\
        //      }\
        //      .DCS-Form .DCS-footerFormButton {\
        //          width: 100% !important;\
        //      }\
        //      .DCS-Form .DCS-bodyFormCheck {\
        //          padding: 0;\
        //      }\
        //      .DCS-bodyFormInput {\
        //          margin-left: 0;\
        //      }\
        //      #mkdiv_p_tel, #mkdiv_p_cp {\
        //          display: block;\
        //          text-align: left;\
        //          padding: 0;\
        //          font-size: 12px;\
        //      }\
        //      #DCS-phone, #DCS-CP {\
        //          width: 100%;\
        //      }\
        //      label[for='DCS-check'] {\
        //          font-weight: 300;\
        //      }\
        //  }\
        //  @media (min-width: 960px) {\
        //      .DCS-bodyFormInput > div {\
        //          width: 92%;\
        //          margin-left: 61px;\
        //      }\
        //  }\
        //  </style>");

        // if (jQuery(".DCS-bodyRpContainer a.drp-phone").length == 0) {
        //     jQuery("head").append("<style type='text/css'>\
        //          .DCS-Form {\
        //              background: #FFF !important;\
        //              height: 480px;\
        //          }\
        //      </style>");
        // }

        // Crear el estilo principal
        var stylePopup = document.createElement("style");
        stylePopup.id = "estilos_popup_variante";
        stylePopup.type = "text/css";
        stylePopup.innerHTML = `
    .dmv-content {
        max-width: 970px !important;
    }
    .DCS-Form {
        background: #FFF !important;
        height: 612px;
    }
    .DCS-headerForm {
        border-bottom: 0 !important;
        padding: 34px 16px 0 0 !important;
    }
    .DCS-headerFormTitle {
        padding-left: 25px;
        padding-right: 25px;
    }
    .DCS-bodyFormMessage {
        display: none;
    }
    .DCS-bodyFormInput {
        margin-left: -62px;
    }
    .DCS-Form .DCS-bodyFormCheck {
        padding: 24px;
    }
    .DCS-headerFormTitle, .DCS-Form .DCS-bodyFormInput, .DCS-footerForm, #cp-salud, div[class='DCS-bodyFormInput']:nth-child(1) {
        text-align: center;
    }
    #DCS-phone, #DCS-CP {
        width: 40%;
    }
    .DCS-footerForm button {
        width: 49% !important;
    }
    #mkdiv_p_tel {
        display: inline-block;
        padding-right: 5px;
        padding-left: 36px;
    }
    #mkdiv_p_cp {
        display: inline-block;
        padding-right: 8px;
    }
    @media (max-width: 960px) {
        .DCS-headerForm {
            padding: 34px 0px 0 0 !important;
        }
        .DCS-Form .DCS-headerFormClose img {
            height: 10px;
        }
        .DCS-Form {
            height: auto;
        }
        .DCS-Form .DCS-footerFormButton {
            width: 100% !important;
        }
        .DCS-Form .DCS-bodyFormCheck {
            padding: 0;
        }
        .DCS-bodyFormInput {
            margin-left: 0;
        }
        #mkdiv_p_tel, #mkdiv_p_cp {
            display: block;
            text-align: left;
            padding: 0;
            font-size: 12px;
        }
        #DCS-phone, #DCS-CP {
            width: 100%;
        }
        label[for='DCS-check'] {
            font-weight: 300;
        }
    }
    @media (min-width: 960px) {
        .DCS-bodyFormInput > div {
            width: 92%;
            margin-left: 61px;
        }
    }
`;
        document.head.appendChild(stylePopup);

        // Comprobar si el elemento no existe y agregar un segundo estilo
        if (document.querySelectorAll(".DCS-bodyRpContainer a.drp-phone").length === 0) {
            var stylePopupSecondary = document.createElement("style");
            stylePopupSecondary.type = "text/css";
            stylePopupSecondary.innerHTML = `
                .DCS-Form {
                    background: #FFF !important;
                    height: 480px;
                }
            `;
            document.head.appendChild(stylePopupSecondary);
        }

        maqueta_popup();

        // jQuery(document).on("click", ".DCSS-c2c .DCS-ClickToCall", function () {
        //     maqueta_popup();
        // });

        document.addEventListener("click", function (event) {

            if (event.target.closest(".DCSS-c2c .DCS-ClickToCall")) {
                maqueta_popup();
            }
        });
    }

    function maqueta_popup() {
        // jQuery(".DCS-headerFormTitle").html("¿Te interesa una fecha posterior a 30 días?");

        // jQuery("#DCS-phone").removeAttr("placeholder");
        // jQuery("#DCS-CP").removeAttr("placeholder");

        // if (jQuery("#mkdiv_p_tel").length == 0 && jQuery("#mkdiv_p_cp").length == 0) {
        //     jQuery("<p id='mkdiv_p_tel'>Teléfono</p>").insertBefore(jQuery("#DCS-phone"));
        //     jQuery("<p id='mkdiv_p_cp'>Código postal</p>").insertBefore(jQuery("#DCS-CP"));
        // }

        document.querySelector(".DCS-headerFormTitle").innerHTML = "¿Te interesa una fecha posterior a 30 días?";

        document.getElementById("DCS-phone").removeAttribute("placeholder");
        document.getElementById("DCS-CP").removeAttribute("placeholder");

        if (!document.getElementById("mkdiv_p_tel") && !document.getElementById("mkdiv_p_cp")) {
            var telElement = document.createElement("p");
            telElement.id = "mkdiv_p_tel";
            telElement.innerText = "Teléfono";
            document.getElementById("DCS-phone").parentNode.insertBefore(telElement, document.getElementById("DCS-phone"));

            var cpElement = document.createElement("p");
            cpElement.id = "mkdiv_p_cp";
            cpElement.innerText = "Código postal";
            document.getElementById("DCS-CP").parentNode.insertBefore(cpElement, document.getElementById("DCS-CP"));
        }
    }
}